import { Component, OnInit, Input } from '@angular/core';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
  useAnimation
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq21',
  templateUrl: './cq21.component.html',
  styleUrls: ['./cq21.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq21Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  showTip = false;
  no_of_locations;
  options = [];
  deviceWidth;
  disablebutton = false;
  showbutton = true;
  timer;
  question_sub1;
  question_sub2;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.deviceWidth = this.commercialService.deviceWidth;
    for (let i = 1; i <= 50; i++) {
      let obj;
      if (i < 51) {
        obj =  i.toString();
      }
      this.options.push(obj);
    }
    this.options[this.options.length] = '50+';
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        this.index = i;
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('the ');
          this.question_sub1 = question_sub1[0] + ' the';
          this.question_sub2 = question_sub1[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.no_of_locations = obj.fieldValue;
        if (!_.isEmpty(this.no_of_locations)) {
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      }
    }

    if(_.isEmpty(this.no_of_locations))
    {
      this.showbutton = false;
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  getLocations(event) {
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
    }
    this.no_of_locations = event;
    this.showTip = true;
    this.user_bot = true;
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    } else{
      if(!this.showbutton)
      {
        this.next();
      }

    }
  }
  
  next() {
    if (_.isEmpty(this.no_of_locations)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.commercialService.messageService({ 'currentId': this.data });
    }
  }

  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'com_question_id': this.data, 'fieldName': 'no_of_locations', 'fieldValue': this.no_of_locations
    };
    this.commercialService.updateResponses(Obj);
  }

}
